import React, { FC, useEffect, useState } from 'react'
import MenuOffcanvas from './MenuOffcanvas';
import logo from 'assets/images/publicHeader.png';
import { Link, NavLink } from 'react-router-dom';
import { DataProvider, EndPoint, DataError } from 'data/Provider';
import { Badge } from 'reactstrap';

const NavigationHeader: FC = () => {

    const [showMenu, setShowMenu] = useState(false);
    const [environment, setEnvironment] = useState('production');
    const toggleMenuPanel = () => setShowMenu(o => !o);


    useEffect(() => {
        retrieveEnvironment();
    }, []);

    const retrieveEnvironment = async () => {
        try {
            const res = await DataProvider.get(EndPoint.APP_ENVIRONMENT);
            let env = await res.data;
            setEnvironment(env.environment);
        } catch (err) {
            console.log('Failed fetch.', err)
            if (err instanceof DataError) {
            }
        }
    }


    return (
        <nav className="navbar navbar-expand-md navbar-light">
            <div className='container-lg d-flex justify-content-between align-items-center'>
                <Link className="navbar-brand d-inline-grid  d-md-block" to='/'>
                    <img src={logo} height="60" alt="Puppies For Parole logo" />
                    {environment === 'TESTWEB' &&
                        <Badge className='test-environment text-dark ms-3' color='hotpink' style={{ width: '95px', maxWidth: '95px' }}>TESTWEB</Badge>
                    }
                </Link>
                <button className="navbar-toggler border-0 p-0" type="button"
                    tabIndex={0}
                    onClick={() => setShowMenu(true)}
                    id="navbarToggler"
                    style={{ borderColor: 'none' }}>
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className='d-none d-md-block'>
                    <div className="ms-auto d-flex align-items-center justify-content-between">
                        <div>
                            <NavLink role="button"
                                //className={({ isActive }) => isActive ? 'bg-success font-bold' : 'bg-red-500 font-thin'}
                                className="btn btn-outline-primary rounded-pill fw-bold d-flex align-items-center"

                                to='/adopt'
                            >
                                <i className="bi bi-heart-fill me-2"></i>
                                How to Adopt
                            </NavLink>
                        </div>
                        <div className="vr mx-3 text-dark" style={{ height: '70px' }}></div>
                        <div>
                            <NavLink
                                role='button'
                                className="btn btn-outline-primary rounded-pill fw-bold d-flex align-items-center"
                                to='/donate'
                            >
                                <i className="bi bi-gift me-2"></i>
                                Donate
                            </NavLink>
                        </div>
                    </div>
                </div>
                <MenuOffcanvas showMenu={showMenu} toggleMenuPanel={toggleMenuPanel} />
            </div>
        </nav>
    )
}

export default NavigationHeader;